import React, { useState, useEffect } from 'react';
import { Button, Col, Row, Form, Card, Spinner, Badge } from 'react-bootstrap';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Select from 'react-select';
import axios from '../../../api/axios';
import Header from '../../../layouts/Header';

const EditMenuIngredients = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { access } = useSelector((state) => state.login);
    const { email } = useSelector((state) => state.login);
    const accessToken = localStorage.getItem("authToken");

    // const ingredientData = location.state?.ingredientData?;

    const { id } = useParams();


    console.log("Ingredient ID :", id);


    const [ingredientData, setIngredientData] = useState({})
    const [categoryList, setCategoryList] = useState([]);
    const [productsList, setProductsList] = useState([]);
    const [rawMaterialList, setRawMaterialList] = useState([]);
    const [addons, setAddons] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const ingredientId = id;

    useEffect(() => {
        getIngredients(ingredientId);
    }, [ingredientId]);


    const getIngredients = async (ingredientId) => {
        setIsLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }

            const response = await axios.get(`recipe`, { headers,
                params: { _id: ingredientId }
            } );
            console.log("Response of Incoming Data :", response?.data?.data?.recieps);
            

            setIngredientData(response?.data?.data?.recieps)
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                toast.error(error.response.data.error);
            }
        } finally {
            setIsLoading(false);
        }
    };

    const [editedData, setEditedData] = useState({
        _id: '',
        product: '',
        rawMaterials: [],
    });

    useEffect(() => {
        // Check access
        if (!access?.includes("MenuIngredients:update") && email !== "contact@xpansecafe.com") {
            toast.error("You don't have permission to access this page");
            navigate('/menu/menu-ingredients');
        }

        // if (!ingredientData) {
        //     toast.error("No ingredient data found");
        //     navigate('/menu/menu-ingredients');
        // }
    }, [access, email, navigate, ingredientData]);

    useEffect(() => {
        fetchInitialData();
    }, []);

    useEffect(() => {
        if (ingredientData && rawMaterialList.length > 0) {
            mapIngredientData();
        }
    }, [ingredientData, rawMaterialList]);

    const fetchInitialData = async () => {
        setIsLoading(true);
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };

            // Fetch categories
            const categoryRes = await axios.get("masters/category/get", { headers });
            if (categoryRes?.data?.status === true) {
                setCategoryList(categoryRes?.data?.data?.categories);
            }

            // Fetch products
            const productRes = await axios.get("product", { headers });
            if (productRes?.data?.status === true) {
                setProductsList(productRes?.data?.data?.products);
            }

            // Fetch raw materials
            const rawMaterialRes = await axios.get("raw-material", { headers });
            if (rawMaterialRes?.data?.status === true) {
                setRawMaterialList(rawMaterialRes?.data?.data?.rawMaterials);
            }

            // Fetch addons
            const addonsRes = await axios.get("addons?page=1&limit=1000", { headers });
            setAddons(addonsRes?.data?.data?.addons);

        } catch (error) {
            toast.error("Error fetching initial data");
        } finally {
            setIsLoading(false);
        }
    };

    const mapIngredientData = () => {
        const mappedRawMaterials = ingredientData?.rawMaterials?.map(item => ({
            _id: item?._id,
            rawMaterial: item?.rawMaterial?._id,
            quantity: item?.quantity || '',
            unit: item?.rawMaterial?.unit || '',
            addonId: item?.addonId?._id || '',
            addonValueId: item?.addonValueId,
            isImportant: item?.isImportant || false,
        })) || [{
            rawMaterial: '',
            quantity: '',
            unit: '',
            addonId: '',
            addonValueId: '',
            isImportant: false,
        }];

        setEditedData({
            _id: ingredientData?._id,
            product: ingredientData?.product?._id || '',
            rawMaterials: mappedRawMaterials,
        });
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditedData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleEditRawMaterialChange = (index, field, value) => {
        const updatedRawMaterials = [...editedData.rawMaterials];

        if (field === 'rawMaterial') {
            const selectedRawMaterial = rawMaterialList.find((rm) => rm._id === value);
            updatedRawMaterials[index].rawMaterial = value;
            updatedRawMaterials[index].unit = selectedRawMaterial ? selectedRawMaterial.unit : '';
        } else {
            updatedRawMaterials[index][field] = value;
        }

        if (field === 'addonId') {
            updatedRawMaterials[index].addonValueId = '';
        }

        setEditedData((prevData) => ({
            ...prevData,
            rawMaterials: updatedRawMaterials,
        }));
    };

    const addRawMaterialEntry = () => {
        setEditedData((prevData) => ({
            ...prevData,
            rawMaterials: [
                ...prevData.rawMaterials,
                {
                    rawMaterial: '',
                    quantity: '',
                    unit: '',
                    addonId: '',
                    addonValueId: '',
                    isImportant: false,
                }
            ],
        }));
    };

    const removeRawMaterialEntry = (index) => {
        setEditedData((prevData) => {
            const newRawMaterials = [...prevData.rawMaterials];
            newRawMaterials.splice(index, 1);

            if (newRawMaterials.length === 0) {
                newRawMaterials.push({
                    rawMaterial: '',
                    quantity: '',
                    unit: '',
                    addonId: '',
                    addonValueId: '',
                    isImportant: false,
                });
            }

            return {
                ...prevData,
                rawMaterials: newRawMaterials
            };
        });
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        // Validation
        const invalidItem = editedData.rawMaterials.find(item =>
            item.addonId?.toString().trim() !== "" && (!item.addonValueId || item.addonValueId.toString().trim() === "")
        );

        if (invalidItem) {
            toast.error("If an Addon is selected, Addon Value must also be selected.");
            setIsSubmitting(false);
            return;
        }

        // Sanitize data
        const sanitizedData = {
            ...editedData,
            rawMaterials: editedData.rawMaterials.map((item) => ({
                ...item,
                addonId: item.addonId?.toString().trim() === "" ? null : item.addonId,
                addonValueId: item.addonValueId?.toString().trim() === "" ? null : item.addonValueId
            }))
        };

        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axios.put("recipe", sanitizedData, { headers });

            if (response?.data?.status === true) {
                toast.success("Ingredients updated successfully");
                navigate('/menu/menu-ingredients');
            }
        } catch (error) {
            let errorMessage = "Error updating ingredients";
            if (error.response?.data?.error) {
                errorMessage = error.response.data.error;
            }
            toast.error(errorMessage);
        } finally {
            setIsSubmitting(false);
        }
    };

    const categoryOptions = categoryList?.map((cat) => ({
        value: cat._id,
        label: cat.name,
    }));

    const productOptions = productsList?.map((product) => ({
        value: product._id,
        label: product.name,
    }));

    if (isLoading) {
        return (
            <>
                <Header />
                <div className="main main-app p-3 p-lg-4 d-flex justify-content-center">
                    <Spinner animation="border" variant="primary" />
                </div>
            </>
        );
    }

    return (
        <>
            <Header />
            <div className="main main-app p-3 p-lg-4">
                <div className="container" style={{ backgroundColor: "white", padding: "1.2rem", borderRadius: "8px" }}>
                    <div className="d-flex align-items-center mb-4">
                        <Button
                            variant="link"
                            className="text-decoration-none p-0 me-3"
                            onClick={() => navigate('/menu/menu-ingredients')}
                        >
                            <i className="ri-arrow-left-line fs-5"></i>
                        </Button>
                        <h5 className="fw-semibold mb-0">EDIT MENU INGREDIENTS</h5>
                    </div>

                    <Form onSubmit={handleEditSubmit}>
                        <Card className="border-0 shadow-sm mb-4">
                            <Card.Body>
                                <h6 className="fw-semibold mb-3">Product Information</h6>
                                <Row>
                                    <Col md="6">
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold small">Category</Form.Label>
                                            <Form.Control
                                                type="text"
                                                size="sm"
                                                value={productsList.find(p => p._id === editedData.product)?.category?.name || ''}
                                                disabled
                                                className="bg-light"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md="6">
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold small">
                                                Menu <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Select
                                                options={productOptions}
                                                value={
                                                    editedData.product
                                                        ? {
                                                            value: editedData?.product,
                                                            label: productsList?.find(
                                                                (product) => product?._id === editedData?.product
                                                            )?.name,
                                                        }
                                                        : null
                                                }
                                                onChange={(selectedOption) => {
                                                    handleEditChange({
                                                        target: {
                                                            name: "product",
                                                            value: selectedOption ? selectedOption.value : "",
                                                        },
                                                    });
                                                }}
                                                classNamePrefix="react-select"
                                                isClearable
                                                placeholder="Select Product"
                                                className="small"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>

                        <Card className="border-0 shadow-sm">
                            <Card.Body>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 className="fw-semibold mb-0">Raw Materials</h6>
                                    <Badge bg="info" className="small">Required fields marked with *</Badge>
                                </div>

                                {editedData.rawMaterials.map((entry, index) => (
                                    <Card key={index} className="mb-4 border">
                                        <Card.Body className="bg-light">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <Badge bg="secondary">Material #{index + 1}</Badge>
                                                {editedData.rawMaterials.length > 1 && (
                                                    <Button
                                                        variant="outline-danger"
                                                        size="sm"
                                                        onClick={() => removeRawMaterialEntry(index)}
                                                    >
                                                        <i className="ri-delete-bin-line me-1"></i>Remove
                                                    </Button>
                                                )}
                                            </div>

                                            <Row className="mb-3">
                                                <Col md={4}>
                                                    <Form.Label className="fw-semibold small">
                                                        Raw Material <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Select
                                                        options={rawMaterialList?.map((rm) => ({
                                                            value: rm._id,
                                                            label: `${rm.name} ${rm?.inStock === false ? "(Out of stock)" : ""}`,
                                                        }))}
                                                        value={
                                                            entry?.rawMaterial
                                                                ? {
                                                                    value: entry?.rawMaterial,
                                                                    label: rawMaterialList?.find(
                                                                        (rm) => rm._id === entry.rawMaterial
                                                                    )?.name,
                                                                }
                                                                : null
                                                        }
                                                        onChange={(selectedOption) =>
                                                            handleEditRawMaterialChange(
                                                                index,
                                                                "rawMaterial",
                                                                selectedOption ? selectedOption.value : ""
                                                            )
                                                        }
                                                        classNamePrefix="react-select"
                                                        isClearable
                                                        placeholder="Select Raw Material"
                                                        className="small"
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Label className="fw-semibold small">
                                                        Quantity <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        size="sm"
                                                        placeholder="Enter quantity"
                                                        value={entry.quantity || ""}
                                                        onChange={(e) =>
                                                            handleEditRawMaterialChange(index, "quantity", e.target.value)
                                                        }
                                                    />
                                                </Col>
                                                <Col md={2}>
                                                    <Form.Label className="fw-semibold small">Unit</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        size="sm"
                                                        disabled
                                                        placeholder="Unit"
                                                        value={entry.unit || ""}
                                                        className="bg-light"
                                                    />
                                                </Col>
                                                <Col md={3} className="d-flex align-items-center">
                                                    <Form.Check
                                                        type="checkbox"
                                                        label="Is Important"
                                                        name={`isImportant-${index}`}
                                                        checked={entry.isImportant || false}
                                                        onChange={(e) =>
                                                            handleEditRawMaterialChange(
                                                                index,
                                                                "isImportant",
                                                                e.target.checked
                                                            )
                                                        }
                                                        className="mt-4 small"
                                                    />
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col md={6}>
                                                    <Form.Label className="fw-semibold small">Addon Group</Form.Label>
                                                    <Select
                                                        options={addons?.map((addon) => ({
                                                            value: addon?._id,
                                                            label: addon?.title,
                                                        }))}
                                                        value={entry?.addonId ? {
                                                            value: entry?.addonId,
                                                            label: addons?.find((a) => a?._id === entry?.addonId)?.title,
                                                        } : null}
                                                        onChange={(selectedOption) => {
                                                            handleEditRawMaterialChange(index, "addonId", selectedOption?.value || "");
                                                            handleEditRawMaterialChange(index, "addonValueId", "");
                                                        }}
                                                        classNamePrefix="react-select"
                                                        isClearable
                                                        placeholder="Select Addon Group (Optional)"
                                                        className="small"
                                                    />
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Label className="fw-semibold small">Addon Value</Form.Label>
                                                    <Select
                                                        options={
                                                            entry.addonId
                                                                ? addons?.find(a => a._id === entry.addonId)?.addonValues?.map(val => ({
                                                                    value: val?._id,
                                                                    label: val?.value,
                                                                })) || []
                                                                : []
                                                        }
                                                        value={
                                                            entry?.addonValueId && entry?.addonId
                                                                ? {
                                                                    value: entry?.addonValueId,
                                                                    label: addons?.find(a => a?._id === entry?.addonId)?.addonValues?.find(v => v?._id === entry?.addonValueId)?.value || "Unknown Value"
                                                                }
                                                                : null
                                                        }
                                                        onChange={(selectedOption) =>
                                                            handleEditRawMaterialChange(index, "addonValueId", selectedOption?.value || "")
                                                        }
                                                        classNamePrefix="react-select"
                                                        isClearable
                                                        placeholder={entry.addonId ? "Select Addon Value" : "Select Addon Group first"}
                                                        isDisabled={!entry.addonId}
                                                        className="small"
                                                    />
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                ))}

                                <Button
                                    variant="outline-success"
                                    size="sm"
                                    className="mt-2"
                                    onClick={addRawMaterialEntry}
                                >
                                    <i className="ri-add-line me-1"></i> Add Another Raw Material
                                </Button>
                            </Card.Body>
                        </Card>

                        <div className="d-flex justify-content-end gap-2 mt-4">
                            <Button
                                variant="secondary"
                                size="sm"
                                onClick={() => navigate('/menu/menu-ingredients')}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="primary"
                                type="submit"
                                size="sm"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? (
                                    <>
                                        <Spinner size="sm" className="me-2" />
                                        Updating...
                                    </>
                                ) : (
                                    'Update Ingredients'
                                )}
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
        </>
    );
};

export default EditMenuIngredients;